var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("p", { staticClass: "flex text-xs" }, [
    _vm._v(" " + _vm._s(_vm.budget) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }